import React from 'react';
import { useTranslation } from 'react-i18next';
import { DogLogo } from '@/app/const/svg';
import { Tooltip } from 'antd';
import { cn } from '@/lib/utils';
import DogsBg from '@/app/assets/image/tags/dog.svg';

interface UserTagsProps {
    size?: string;
    userLabels?: string;
    className?: string;
    showTooltip?: boolean;
}
export default function UserTags({
    userLabels = '',
    size = '4',
    className = '',
    showTooltip = false,
}: UserTagsProps) {
    const { t } = useTranslation();
    const sizeClass = 'size-' + size;
    let newTags: string[] = [];
    try {
        newTags = JSON.parse(userLabels);
    } catch (error) {
        newTags = [];
    }
    if (!userLabels || newTags.length === 0) {
        return null;
    }
    
    if (newTags.includes('dog')) {
        return  (
            <Tooltip title={showTooltip ?(
                <div className="flex flex-col flex-wrap gap-2 items-center justify-center pb-2">
                    <img
                        src={DogsBg}
                        alt="DogsBg"
                        className="size-32"
                    />
                    <h3 className="text-base font-medium text-font-primary text-center">{t('userTags.foundingMember')}</h3>
                    <p className="text-xs text-font-primary/50 text-center px-4">
                        {t('userTags.foundingMemberDesc')}
                    </p>
                </div>
            ) : null}>
                <div className={cn('inline-flex align-middle', className)}>
                    <DogLogo className={cn(showTooltip ? 'cursor-pointer' : '', sizeClass)}/> 
                </div>
            </Tooltip>
        )
    }
}
